<template>
  <div class="results classroom">
     <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/"> {{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("nav.zxzj") }} </BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div class="results-wrap">
      <div class="headtitle">咨询培训服务</div>
      <div class="s1">
        <div class="title">课程内容</div>
        <table cellpadding="0" cellspacing="0" class="table1">
          <thead><tr><td style="width:40%;">课程分类</td><td>课程名称</td></tr></thead>
          <tbody>
            <tr>
              <td class="name">通关实务</td>
              <td class="value">
                <table cellpadding="0" cellspacing="0" class="table2">
                  <tr><td>海关监管模式改革：趋势、影响、应对</td><td style="width:80px"><span style="color:red">HOT</span></td></tr>
                  <tr><td>特许权使用费及政策解析</td><td>&nbsp;</td></tr>
                  <tr><td>进出口管制与合规风险</td><td>&nbsp;</td></tr>
                  <tr><td>中国海关监管模式概述</td><td><span style="color:red">HOT</span></td></tr>
                  <tr><td>海关AEO新政正式实施，原一般认证企业如何应对！</td><td>&nbsp;</td></tr>
                  <tr><td class="more">更多……</td><td><span style="color:red">HOT</span></td></tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="name">RCEP政策</td>
              <td class="value">
                <table cellpadding="0" cellspacing="0" class="table2">
                  <tr><td>RCEP原产地规则——海关及贸易便利化解读</td><td style="width:80px">&nbsp;</td></tr>
                  <tr><td>RCEP优惠政策及原产地规则解读</td><td><span style="color:red">HOT</span></td></tr>
                  <tr><td>RCEP零关税政策&amp;经核准的出口商管理制度解析</td><td>&nbsp;</td></tr>
                  <tr><td>FTA应用风险评估排查</td><td>&nbsp;</td></tr>
                  <tr><td>FTA自由贸易协定认识与应用</td><td>&nbsp;</td></tr>
                  <tr><td class="more">更多……</td><td><span style="color:red">HOT</span></td></tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="name">跨境贸易</td>
              <td class="value">
                <table cellpadding="0" cellspacing="0" class="table2">
                  <tr><td>危险品化学品进出口知多少？</td><td style="width:80px">&nbsp;</td></tr>
                  <tr><td>加工贸易基础知识与实操</td><td style="width:80px">&nbsp;</td></tr>
                  <tr><td>数字经济与跨境电商的发展</td><td style="width:80px"><span style="color:red">HOT</span></td></tr>
                  <tr><td>9810、9710？跨境电商新政独家详解</td><td>&nbsp;</td></tr>
                  <tr><td>跨境电商新政策解读</td><td style="width:80px">&nbsp;</td></tr>
                  <tr><td class="more">更多……</td><td>&nbsp;</td></tr>
                </table>
              </td>
            </tr>
            <tr>
              <td class="name">贸易合规经理人(所有课程培训完毕可发放电子结业证书）</td>
              <td class="value">
                <table cellpadding="0" cellspacing="0" class="table2">
                  <tr><td>中美贸易摩擦影响与供应链应对</td><td style="width:80px"><span style="color:red">HOT</span></td></tr>
                  <tr><td>国际贸易术语（Incoterms 2020）解析及应用</td><td>&nbsp;</td></tr>
                  <tr><td>智能科技在数字贸易中的应用</td><td><span style="color:red">HOT</span></td></tr>
                  <tr><td>跨境物流管理的核心问题及应对措施</td><td>&nbsp;</td></tr>
                  <tr><td>自由贸易试验区：发展概述· 政策解析· 实践应用</td><td><span style="color:red">HOT</span></td></tr>
                  <tr><td class="more">更多……</td><td>&nbsp;</td></tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="s2">
        <div class="wrap">
          <Row :gutter="60" type="flex">
            <Col span="16" class="p1">
              <Row :gutter="0" type="flex">
                <Col span="12">
                  <div class="wrap wrap-left">
                    <div class="title">RCEP政策系列课程</div>
                    <div class="desc">在提升高质量实施RCEP大背景下，邀请到行业、学术及院校的RCEP专家，从理论结合实操的角度，深入解读RCEP政策及运用。</div>
                  </div>
                </Col>
                <Col span="12">
                  <div class="wrap">
                    <div class="title">跨境贸易系列课程</div>
                    <div class="desc">将跨境贸易中各个环节为从业人员一一进行讲解，包含进出口涉及报关、报检、外汇、出口退税等多个环节，及跨境电商的注意事项。</div>
                  </div>
                </Col>
                <Col span="12">
                  <div class="wrap  wrap-left">
                    <div class="title">通关实务系列课程</div>
                    <div class="desc">结合海关监管，实务操作，通关各个环节的注意事项，由行业资深讲师，讲解通关中需要注意的问题和常识。</div>
                  </div>
                </Col>
                <Col span="12">
                  <div class="wrap">
                    <div class="title">贸易合规经理人认证课程</div>
                    <div class="desc">为行业稀缺人才提供的专业合规经理人认证课程，培养贸易合规管理人才。</div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span="8" class="p2">
              <div class="wrap">
                <div class="title">线上课程</div>
                <div class="desc">
                  <p>线上录播课程设置目的：</p>
                  <p>让政府通过提供培训课件给到当地企业，让企业随时随地自主组织学习，企业内个人也可利用碎片化时间听课，并且在听完所有课程后，可获取电子结业证书，帮助企业培养专业化人才，同时帮助行业从业人员专业知识提升。</p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s3">
        <div class="s3Wrap">
          <Row :gutter="30" type="flex">
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/icons/s31.png">
                <div class="info">
                  <div class="title">线下培训</div>
                  <div class="desc">配合地方各部门提供定期线下面对面的专业培训，现场解答企业遇到的问题。</div>
                </div>
              </div>
            </Col>
            <Col span="12">
              <div class="wrap">
                <img src="~@/assets/images/icons/s32.png">
                <div class="info">
                  <div class="title">线下咨询</div>
                  <div class="desc">协助政府相关部门，通过线上问卷、实地走访和深度座谈等多种调研方式，了解企业应用现状、需求和遇到的困难。为政府制定产业政策提供决策参考。</div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="s4">
        <div class="s4Wrap">
          <div class="headtitle">培训风采</div>
          <div class="list">
            <a class="item" v-for="(item, index) in news" :key="index" target="_blank" :href="item.url">
              <div class="imaeWrap" :style="{background: `url(${item.image}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
              <div class="info">
                <div class="title">{{item.title}}</div>
                <div class="desc">{{item.desc}}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <ZX></ZX>
    </div>
  </div>
</template>

<script>
import ZX from '@/components/layout/ZX'
export default {
  name: 'RcepClassroom',
  components: { ZX },
  data () {
    return {
      news: [
        {
          id: 1,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247525872&idx=1&sn=ce6095e70518279e3e603c7330923a2c&chksm=9b361031ac419927eafbfe114765fb49531a95aa6626e25b8dacab2b3856b3d16b6d083330ae&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/1.jpg'),
          title: '科橘新闻 | 科橘科技受商务部邀请为参加首场全国RCEP系列专题培训的企业讲解关税减让综合应用方案',
          desc: '为贯彻落实国务院常务会议关于加强RCEP宣介培训工作部署，由商务部主办的全国RCEP系列专题培训于4月11日开启首次培训，上海科橘信息有限公司受商务部邀请开展此次全国范围内的RCEP专题培训。第一场全国RCEP系列专题培训将以分片区的形式举办，全程线上进行，培训片区覆盖广西壮族自治区、重庆市、四川省、云南省、西藏自治区、甘肃省、青海省、新疆维吾尔自治区等省区市代表性外经贸企业及各省区市监管部门负责人。'
        },
        {
          id: 2,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247525441&idx=1&sn=1f470c1594573aefdb0d7f7864d66168&chksm=9b361180ac419896bc487652c8b39bea6fd7348b01c43b26c0942d7bdc8e4daa34b8d8ccda01&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/2.png'),
          title: '科橘新闻 | 当双循环与RCEP相遇，科橘科技协助各地方政府指导企业用足用好RCEP政策红利',
          desc: '近日，受商务部培训中心及商务部国际贸易经济合作研究院邀请，世界海关组织原产地认证专家，上海科橘信息科技有限公司CEO厉力博士在多地陆续开展RCEP宣讲和培训，围绕RCEP优惠关税政策、经核准出口商、原产地规则、海关监管及企业高效利用RCEP政策红利等内容进行解读和分析。3月以来，厉力博士已为宁波、湖北、山西、云南、福州等多地为进出口企业、物流企业、跨境电商和金融机构等超2000名企业人员及相关地方政府部门领导干部开展培训并进行针对性答疑。'
        },
        {
          id: 3,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247522845&idx=1&sn=35787da140d3d75e1c58d9431c454641&chksm=9b36efdcac4166ca0c3e06a31f55c4e552dc561b8a699179fe1a2eb7c1090f9b9a3545c9b9fe&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/3.jpg'),
          title: '科橘新闻 | 科橘科技CEO厉力博士受邀为闵行外贸企业解读RCEP中的“新机遇、新赋能”',
          desc: '2月22日，由闵行区经委会会同莘庄海关、中国银行共同举办的“新机遇、新赋能”RCEP 政策及实务宣讲会在上海市闵行区举行。科橘科技创始人、WCO原产地专家厉力博士、上海海关关税处鲁晓倩副科长、中国银行上海市分行资深外汇交易员吴俊受邀为闵行区多家企业进行专题宣讲。区经委副主任沈丽、刘文娟及相关科室、莘庄海关、中国银行及40余位 RCEP 贸易领域相关企业代表参会。 此次宣讲会从理论到实务，全方位、多维度地对RCEP进行专业解读，RCEP 贸易领域相关企业代表对本次培训表现出了高度热情和浓厚兴趣，在提问环节也与与会专家们踊跃交流互动。'
        },
        {
          id: 4,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247518389&idx=1&sn=a447b56fed889d091a3f693f7a97f265&chksm=9b36fd74ac41746283b159f531634d40a9c4e71ea5252440cdc5373c25e65bccbbc8665c3641&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/4.jpg'),
          title: '科橘新闻 | 科橘科技CEO厉力博士受邀为中国快递物流企业利用RCEP贸易便利措施献策',
          desc: '1月19日下午，由物流信息互通共享技术及应用国家工程实验室和长三角流通经济创新研究中心主办，上海长三角商业创新研究院、上海跨境电子商务行业协会等指导的“RCEP大背景下中国物流企业的创新与国际化研讨会”在上海市青浦区顺利举办。'
        },
        {
          id: 5,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247518207&idx=1&sn=3843fa8f19d694292d47ba038addb231&chksm=9b36f23eac417b28c6e2f9ee49c63a805b663a7df7342e10bcc95bce7bb4bcfe74a6c8c8b85a&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/5.jpg'),
          title: '科橘新闻 | 科橘科技受青浦区商务委邀请，为重点企业提供RCEP贸易便利化专题培训',
          desc: '1月19日，由青浦商务委员会主办的“RCEP贸易便利化专题培训”在上海市青浦党校举行。本次培训会围绕RCEP经核准出口商、原产地规则、原产地证明申领等主题，邀请WCO原产地专家、科橘科技创始人厉力博士，上海市贸促会FTA专家李蒙为青浦区多家企业进行专题培训，上海市青浦区商务委员会相关领导出席会议并讲话。'
        },
        {
          id: 6,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247515995&idx=1&sn=510006a3656cb4c129515a8bbdfabfc7&chksm=9b36ca9aac41438ca6c2cb50651c896866d85df8069373ef9d6f528182558ca56a8268913ca2&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/6.jpg'),
          title: 'RCEP倒计时1天! | 临港新片区RCEP企业培训会成功举办，科橘科技年度FTA培训同步收官！',
          desc: '12月31日，由临港新片区管委会主办，上海科橘信息科技有限公司协办的“RCEP专题培训——企业如何尽享RCEP贸易便利化红利”企业培训会在临港新片区管委会多功能厅举行。本次培训会围绕RCEP经核准出口商、原产地规则、原产地证明申领以及AEO新政四个议程展开，邀请上海海关、洋山海关、上海临港新片区管委会、上海市贸促会相关领导出席会议并讲话，多家临港新片区的企业参与培训。'
        },
        {
          id: 7,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247493074&idx=1&sn=c2835ba0ee348c26353ef8df8c17ac51&chksm=9b369013ac4119055abb491ce6be0b9b8ae058b838a77627ee8f4c281e3d15acb7a0abf082b2&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/7.jpg'),
          title: '科橘科技CEO厉力博士受邀为苏州贸促会员单位进行RCEP原产地规则培训',
          desc: '在疫情冲击、中美关系紧张、RCEP自贸协定签署、双循环新发展格局的大背景影响下，为提振企业“走出去”信心，助力企业理解并合理优化利用RCEP原产地规则，12月15日，江苏贸促会联合苏州进出口集团、苏州大学长三角绿色供应链研究院在苏州（虹桥）国际会客厅共同举办“RCEP惠企业”主题培训。此次活动邀请到世界海关组织认证专家、上海市曙光学者、上海科橘信息科技有限公司CEO厉力博士、世界自由贸易区联合会执行秘书长杨永新和北京金杜律师事务所上海分所高级顾问孙兴三位专家为80余家外贸企业进行RCEP专题辅导讲解。'
        },
        {
          id: 8,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247514761&idx=1&sn=65678f8c66c4721c5640f44d440c2c2b&chksm=9b36cf48ac41465e55997da9649c68c26198eac1a87f6166f2c3b4bc4496b4d763e4b3a2bb2c&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/8.jpg'),
          title: '2021年FTA辅导与合规风险评估项目圆满收官，科橘科技助力苏企提升国际化经营能力',
          desc: '近日，2021年度FTA辅导与合规风险评估总结会圆满结束。江苏省贸促会领导、FTA智库专家、科橘业务专家等参加了此次项目验收活动，江苏贸促会秘书长杜培军出席并致辞。自6月18日FTA辅导与合规风险评估活动启动以来，通过“贸促服务助企行”“FTA惠苏企”专题活动，江苏省贸促会及科橘业务专家通过线上视频咨询和线下实地考察两种方式，为江苏省重点产业和龙头企业开展了15次RCEP巡回宣讲，提供“FTA与关税筹划咨询”的一站式服务，并形成多篇调研报告。'
        },
        {
          id: 9,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247505012&idx=1&sn=b692a19101135c438e1914b415b02213&chksm=9b36a1b5ac4128a30169153a30ae1644ad680d17de7a074d396a98afc0cc0ee882b751685be7&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/9.jpg'),
          title: 'FTA辅导与合规风险评估活动圆满收官，科橘科技助力企业尽享FTA优惠政策',
          desc: '9月23日，FTA辅导与合规风险评估活动在苏州圆满收官。江苏省贸促会肖铁军会长和FTA智库专家、科橘业务专家及省、市贸促会相关人员参加了此次活动。目前我国已与全球26个国家和地区签署了19个FTA，推广实施FTA工作是当前区域经济一体化加速新形势下稳外贸、稳外资的切实举措。'
        },
        {
          id: 10,
          url: 'https://mp.weixin.qq.com/s?__biz=MzAwMzg5MjM5OA==&mid=2247496951&idx=1&sn=a9244b34e3a482b3c32f9587dedbcb29&chksm=9b368136ac4108205e4d485f9e6c2a3a7ab41c6cdd3c6815019ef33b94989f11eb75e0938314&token=442987666&lang=zh_CN#rd',
          image: require('@/assets/images/rcep/10.jpg'),
          title: '“FTA辅导与国际贸易合规风险评估”项目在江苏省启动，科橘科技协助江苏省贸促会开展企业调研',
          desc: '6月18日下午，江苏省贸促会主持召开2021年“FTA辅导与国际贸易合规风险评估项目”启动会。省贸促会肖铁军会长、法律部汪洋部长，苏州贸促会、常州贸促会、南通贸促会的分会领导、FTA智库专家、科橘科技业务专家，以及16家代表企业的负责人参会。肖会长在会上指出，当前区域经济一体化加速，我国已与全球26个国家和地区签署了19个FTA，推广实施FTA工作是贸促会落实自贸区战略的重要职能，是新形势下稳外贸、稳外资的切实举措。此次FTA辅导与国际贸易合规风险评估活动，希望能够达到3个目标：首先能够帮助企业进一步降低成本、提高出口产品竞争力，让企业做到FTA优惠工作应享尽享；其次帮助企业更好地开拓国际市场，利用FTA，帮助企业加入全球区域生产网络和产品供应链；最后帮助企业做好原产地合规工作，减少违规被稽查的风险。'
        },
      ]
    }
  }
}
</script>

<style scoped>
.results{
  position: relative;
  padding: 15px 0 25px;
}
.results-wrap{
  width:1400px;
  margin: 0 auto;
  padding-bottom: 20px;
  max-width: var(--contentPageMaxWidth);
}
.s1{
  /* width: 90%; */
  margin: 0 auto;
}
.headtitle, .s1 .title{
  font-size: 2.6rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
  text-align: center;
}
.headtitle {
  text-align: left;
}
.table1{
  width: 100%;
  border: 2px solid #194789;
  border-top: 0 none;
  border-collapse: collapse;
}
.table1 thead tr td{
  background-color: #194789;
  text-align: center;
  color: #fff;
  font-size: 14px;
  padding: 3px 0;
  font-weight: bold;
}
.table1 tbody .name{
  color: #333;
  font-size: 16px;
  font-weight: bold;
  padding: 0 10px;
  border-right: 0.5px solid #194789;
  border-bottom: 0.5px solid #194789;
}
.table1 tbody tr:last-child .name{
  border-bottom: 0 none;
}
.table2{
  width: 100%;
  border-collapse: collapse;
}
.table2 tr td{
  border-bottom: 0.5px solid #194789;
  padding-left: 10px;
  font-size: 14px;
  padding: 3px 0;
  padding-left: 10px;
}
.table1 tbody tr:last-child .table2 tr:last-child td{
  border-bottom: 0 none;
}
.table2 tr td img{
  width: 18px;
}
.table2 .more{
  padding-left: 42%;
}
.s2{
  margin-top: 40px;
}
.s2 .wrap{
  background-color: #f1f5fb;
}
.s2 .p2, .s2 .p2 .wrap{
  background-color: #194789;
}
.s2 .p1 >>> .ivu-row-flex{
  padding-top: 30px;
}
.s2 .p1 >>> .ivu-col{
  padding-bottom: 30px;
}
.s2 .p1 >>> .ivu-col .wrap{
  padding-left: 30px;
}
.s2 .p1 >>> .ivu-col .wrap-left{
  padding-left: 0;
}
.s2 .p1 .title{
  color: #5981c5;
  font-size: 16px;
  font-weight: bold;
  text-shadow: 2px 2px 5px rgba(89, 129, 197, .5);
  margin-bottom: 5px;
}
.s2 .p1 .desc{
  text-align: justify;
  font-size: 14px;
}
.s2 .p2{
  color: #fff;
  font-size: 14px;
  padding-top: 30px;
}
.s2 .p2 .title{
  font-size: 2.4rem;
  margin-bottom: 20px;
}
.s2 .p2 .desc{
  font-size: 15px;
}
.s3{
  margin-top: 40px;
  /* padding: 0 30px; */
}
.s3 .wrap{
  position: relative;
  padding-left: 90px;
  min-height: 60px;
}
.s3 img{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 60px;
}
.s3 .title{
  font-size: 2.4rem;
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
}
.s3 .desc{
  font-size: 15px;
  line-height: 26px;
  text-align: justify;
}
.s4{
  margin-top: 40px;
  padding: 0 30px;
}
.s4 .headtitle{
  font-size: 2.6rem;
  margin-bottom: 0;
}
.s4 .item{
  position: relative;
  min-height: 162px;
  display: block;
  color: #333;
  padding: 30px 0 30px 230px;
  border-bottom: 0.5px solid #999;
}
.s4 .item:last-child{
  border-bottom: 0 none;
}
.s4 .item:hover{
  color: #333;
}
.s4 .item:hover .title{
  color: #ffa000;
}
.s4 .item .imaeWrap{
  width: 158px;
  height: 102px;
  position: absolute;
  top: 30px;
  left: 0;
}
.s4 .item .info .title{
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 16px;
}
.s4 .item .info .desc{
  font-size: 14px;
  line-height: 24px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
}
</style>

<style>
@media print,screen and (min-width:2300px) {
  .classroom .headtitle, .classroom .s1 .title{
    font-size: 3rem;
  }
  .classroom .table1 thead tr td{
    font-size: 16px;
  }
  .classroom .table1 tbody .name{
    font-size: 18px;
  }
  .classroom .table2 tr td{
    font-size: 16px;
  }
  .classroom .table2 tr td img{
    width: 20px;
  }
  .classroom .s2 .p1 .title{
    font-size: 18px;
  }
  .classroom .s2 .p1 .desc{
    font-size: 16px;
  }
  .classroom .s2 .p2{
    font-size: 16px;
  }
  .classroom .s2 .p2 .title{
    font-size: 2.6rem;
  }
  .classroom .s2 .p2 .desc{
    font-size: 17px;
  }
  .classroom .s3 .title{
    font-size: 2.6rem;
  }
  .classroom .s3 .desc{
    font-size: 17px;
  }
  .classroom .s4 .headtitle{
    font-size: 3rem;
  }
  .classroom .s4 .item .info .title{
    font-size: 18px;
  }
  .classroom .s4 .item .info .desc{
    font-size: 16px;
  }
}
.ivu-row-flex{
  margin-left: 0 !important;
   margin-right: 0 !important;
}

</style>


// WEBPACK FOOTER //
// src/components/news2/ClassRoom.vue